var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtisteInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "493px",
    height: "493px",
    viewBox: "0 0 493 493",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram-ctr") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "1.81949774%",
    cy: "90.8445653%",
    fx: "1.81949774%",
    fy: "90.8445653%",
    r: "144.605412%",
    gradientTransform: "translate(0.018195,0.908446),scale(0.999797,1.000000),rotate(-3.000089),translate(-0.018195,-0.908446)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47133",
    offset: "26.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3081",
    offset: "60.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C63D2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "1.81367144%",
    cy: "90.830228%",
    fx: "1.81367144%",
    fy: "90.830228%",
    r: "144.603851%",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47133",
    offset: "26.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3081",
    offset: "60.91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C63D2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App_prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram-ctr",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1,13.2 C68.9,19.5 55.2,27.9 41.5,41.6 C27.8,55.2 19.4,69 13.1,85.1 C7,100.7 2.9,118.6 1.7,144.8 C0.5,171 0.2,179.4 0.2,246.2 C0.2,313 0.5,321.4 1.7,347.6 C2.9,373.8 7.1,391.7 13.1,407.3 C19.4,423.5 27.8,437.2 41.5,450.9 C55.2,464.6 68.9,473 85.1,479.3 C100.7,485.4 118.6,489.5 144.8,490.7 C171,491.9 179.4,492.2 246.2,492.2 C313,492.2 321.4,491.9 347.6,490.7 C373.8,489.5 391.7,485.3 407.3,479.3 C423.5,473 437.2,464.6 450.9,450.9 C464.6,437.2 473,423.5 479.3,407.3 C485.4,391.7 489.5,373.8 490.7,347.6 C491.9,321.4 492.2,313 492.2,246.2 C492.2,179.4 491.9,171 490.7,144.8 C489.5,118.6 485.3,100.7 479.3,85.1 C473,69 464.6,55.2 451,41.6 C437.3,27.9 423.6,19.5 407.4,13.2 C391.8,7.1 373.9,3 347.7,1.8 C321.5,0.6 313.1,0.3 246.3,0.3 C179.5,0.3 171.1,0.6 144.9,1.8 C118.6,2.9 100.7,7.1 85.1,13.2 Z M345.6,46 C369.6,47.1 382.6,51.1 391.3,54.5 C402.8,59 411,64.3 419.6,72.9 C428.2,81.5 433.5,89.7 438,101.2 C441.4,109.9 445.4,122.9 446.5,146.9 C447.7,172.8 447.9,180.6 447.9,246.3 C447.9,312 447.6,319.8 446.5,345.7 C445.4,369.7 441.4,382.7 438,391.4 C433.5,402.9 428.2,411.1 419.6,419.7 C411,428.3 402.8,433.6 391.3,438.1 C382.6,441.5 369.6,445.5 345.6,446.6 C319.7,447.8 311.9,448 246.2,448 C180.5,448 172.7,447.7 146.8,446.6 C122.8,445.5 109.8,441.5 101.1,438.1 C89.6,433.6 81.4,428.3 72.8,419.7 C64.2,411.1 58.9,402.9 54.4,391.4 C51,382.7 47,369.7 45.9,345.7 C44.7,319.8 44.5,312 44.5,246.3 C44.5,180.6 44.8,172.8 45.9,146.9 C47,122.9 51,109.9 54.4,101.2 C58.9,89.7 64.2,81.5 72.8,72.9 C81.4,64.3 89.6,59 101.1,54.5 C109.8,51.1 122.8,47.1 146.8,46 C172.7,44.8 180.5,44.6 246.2,44.6 C311.9,44.6 319.7,44.8 345.6,46 Z",
    id: "Shape",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9,246.3 C119.9,316.1 176.5,372.6 246.2,372.6 C315.9,372.6 372.5,316 372.5,246.3 C372.5,176.6 316,120 246.2,120 C176.4,120 119.9,176.5 119.9,246.3 Z M328.2,246.3 C328.2,291.6 291.5,328.3 246.2,328.3 C200.9,328.3 164.2,291.6 164.2,246.3 C164.2,201 200.9,164.3 246.2,164.3 C291.5,164.3 328.2,201 328.2,246.3 Z",
    id: "Shape",
    fill: "url(#radialGradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#654C9F",
    cx: 377.6,
    cy: 115,
    r: 29.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisteInsta);
export default __webpack_public_path__ + "static/media/artiste_insta.a2e97000d6af4df93f4c6248dffaebcd.svg";
export { ForwardRef as ReactComponent };